import { storefront } from "../config/storefront.js";

export function formatMoney(cents, currency = storefront.currency) {
  return new Intl.NumberFormat(storefront.locale, {
    style: "currency",
    currency,
    maximumFractionDigits: cents % 100 === 0 ? 0 : 2
  }).format(cents / 100);
}
